import React, { useState, useRef, useEffect } from 'react';
import InputMask from 'react-input-mask';
import './PhoneInput.css';

const countries = [
    { code: '+7', name: 'KZ', flag: '🇰🇿', mask: '+7 (999) 999 99 99', country: 'Kazakhstan' },
    { code: '+7', name: 'RU', flag: '🇷🇺', mask: '+7 (999) 999 99 99', country: 'Russia' },
    { code: '+86', name: 'CN', flag: '🇨🇳', mask: '+86 (999) 9999 9999', country: 'China' },
    { code: '+998', name: 'UZ', flag: '🇺🇿', mask: '+998 (99) 999 99 99', country: 'Uzbekistan' },
    { code: '+996', name: 'KG', flag: '🇰🇬', mask: '+996 (999) 999 999', country: 'Kyrgyzstan' },
];

const PhoneInput = ({ label, value, onChange, onCountryChange }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const blurTimeoutRef = useRef(null);
    const inputId = `phone-input-${Math.random().toString(36).substr(2, 9)}`;

    // Ref callback to avoid findDOMNode warning
    const setInputRef = (element) => {
        inputRef.current = element;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            if (blurTimeoutRef.current) {
                clearTimeout(blurTimeoutRef.current);
            }
        };
    }, []);

    const handleFocus = () => {
        setIsFocused(true);
        setIsDropdownOpen(false);
    };

    const handleBlur = () => {
        const handleBlurTimeout = () => {
            if (!isDropdownOpen) {
                setIsFocused(false);
            }
        };
        blurTimeoutRef.current = setTimeout(handleBlurTimeout, 200);
    };

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setIsDropdownOpen(false);
        if (onCountryChange) {
            onCountryChange(country);
        }
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handlePhoneChange = (e) => {
        onChange(e);
    };

    const phoneValue = value || '';
    const hasValue = phoneValue.replace(/\D/g, '').length > 0;

    return (
        <div className={`phone_input_wrapper ${isFocused || hasValue ? 'is_focused' : ''}`}>
            {label && (
                <label 
                    htmlFor={inputId}
                    className={`phone_input_label ${isFocused || hasValue ? 'label_focused' : ''}`}
                >
                    {label}
                </label>
            )}
            <div className="phone_input_container">
                <div 
                    className={`country_code_dropdown ${isDropdownOpen ? 'dropdown_open' : ''}`}
                    ref={dropdownRef}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    <span className="country_flag">{selectedCountry.flag}</span>
                    <span className="country_code">{selectedCountry.code}</span>
                    <span className={`dropdown_arrow ${isDropdownOpen ? 'rotated' : ''}`}>▼</span>
                    {isDropdownOpen && (
                        <div className="country_dropdown_list">
                            {countries.map((country, index) => (
                                <div
                                    key={index}
                                    className={`country_dropdown_item ${selectedCountry.code === country.code && selectedCountry.name === country.name ? 'selected' : ''}`}
                                    onClick={() => handleCountrySelect(country)}
                                >
                                    <span className="country_flag">{country.flag}</span>
                                    <span className="country_code_text">{country.code}</span>
                                    <span className="country_name">{country.name}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="phone_input_field_wrapper">
                    <InputMask
                        id={inputId}
                        mask={selectedCountry.mask.replace(selectedCountry.code, '').trim()}
                        value={phoneValue}
                        onChange={handlePhoneChange}
                        className="phone_input_field"
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        inputRef={setInputRef}
                        placeholder=""
                    />
                </div>
            </div>
        </div>
    );
};

export default PhoneInput;
